import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';

const API_BASE = process.env.REACT_APP_BACKEND_URL + '/api';

const BrandContext = createContext({
  brandName: 'Deal Track',
  companyName: '',
  setupRequired: false,
  loaded: false,
  refresh: () => {},
});

export const BrandProvider = ({ children }) => {
  const [state, setState] = useState({
    brandName: 'Deal Track',
    companyName: '',
    setupRequired: false,
    loaded: false,
  });

  const refresh = async () => {
    try {
      const res = await axios.get(`${API_BASE}/setup/status`);
      const d = res.data || {};
      setState({
        brandName: d.brand_name || 'Deal Track',
        companyName: d.company_name || '',
        setupRequired: !!d.setup_required,
        loaded: true,
      });
      // Update document title so browser tab matches
      if (typeof document !== 'undefined' && d.brand_name) {
        document.title = d.brand_name;
      }
    } catch {
      setState((s) => ({ ...s, loaded: true }));
    }
  };

  useEffect(() => { refresh(); }, []);

  return (
    <BrandContext.Provider value={{ ...state, refresh }}>
      {children}
    </BrandContext.Provider>
  );
};

export const useBrand = () => useContext(BrandContext);
